import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "select mb-3 mt-2" }
const _hoisted_2 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alterarIdioma($event)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.idiomas, (idioma, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: idioma.idioma,
          selected: idioma.idioma === _ctx.idiomaVigente
        }, _toDisplayString(idioma.titulo), 9, _hoisted_2))
      }), 128))
    ], 32)
  ]))
}